import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageEnum } from 'src/app/enums/language.enum';
import { Lookup } from 'src/app/models/lookup.model';
import { UserProfile } from 'src/app/models/userProfile.model';
import { trackById } from 'src/app/shared/utils/track-by.util';

@Component({
    standalone: false,
    selector: 'app-account-region-tab',
    templateUrl: './account-region-tab.component.html',
    styleUrls: ['./account-region-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountRegionTabComponent {
    @Input() timezones: Lookup[] = [];
    @Input() languages: Lookup[] = [];
    @Input() timeFormats: Lookup[] = [];
    @Input() dateFormats: Lookup[] = [];
    @Input() timeZoneId: string | null = null;
    @Input() languagePreference: LanguageEnum | null = null;
    @Input() timePreference: number | null = null;
    @Input() datePreference: number | null = null;
    @Input() locationDisplay: string | null = null;
    @Output() changed = new EventEmitter<Partial<UserProfile>>();
    @Output() setLocation = new EventEmitter<void>();

    timezoneSearchValue = '';
    readonly trackById = trackById;

    onTimeZoneChange(timeZoneId: string): void {
        this.changed.emit({ timeZoneId });
    }

    onLanguageChange(languagePreference: LanguageEnum): void {
        this.changed.emit({ languagePreference });
    }

    onTimePreferenceChange(timePreference: number | string): void {
        this.changed.emit({ timePreference: Number(timePreference) });
    }

    onDatePreferenceChange(datePreference: number | string): void {
        this.changed.emit({ datePreference: Number(datePreference) });
    }
}
